import { styled } from "@mui/material/styles";
import MuiTableContainer, { TableContainerProps } from "@mui/material/TableContainer";


const TableContainer = styled((props: TableContainerProps) =>
  <MuiTableContainer {...props} />
)(({ theme }) => ({
  maxHeight: "100%",
  background: theme.palette.background.paper,
}));

export default TableContainer;
